export default __webpack_public_path__ + "static/media/Foggy cenote_primary.cc2e7b64.jpg";